// src
import { logoutURL } from "services/cas";
import { clearStorage } from "utils/storage";

export default () => {
  clearStorage();
  window.location.href = logoutURL;
  return null;
};
